/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setSwiper.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __00: 初期設定
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

export function setSwiper() {
    let getPathName = location.pathname;

    if (getPathName.match(/(works)/g)) {
        const content = document.querySelectorAll('.works__content');
        const init = { loop: true, speed: 1000, autoplay: { disableOnInteraction: false, delay: 3000, }, }

        content.forEach((el) => {
            let subSlider = el.querySelector('.sub-slider');
            let subOption = {
                ...init,
                spaceBetween: 6,
                slidesPerView: 5,
                breakpoints: { 835: { spaceBetween: 13, slidesPerView: 9, }, },
                grabCursor: true,
            }
            let subSwiper = new Swiper(subSlider, Object.assign(subOption));

            let mainSlider = el.querySelector('.main-slider');
            let mainOption = {
                ...init,
                slidesPerView: "auto",
                navigation: {
                    prevEl: '.prev-button',
                    nextEl: '.next-button',
                },
                thumbs: {
                    swiper: subSwiper,
                },
            }
            let mainSwiper = new Swiper(mainSlider, Object.assign(mainOption));
        });
    }

    //TOPページのみ
    if (window.document.body.classList.contains("home")) {
        const gallery = document.querySelector('.works__gallery');
        const slideLength = document.querySelectorAll('.works__gallery .works__gallery-post').length;

        const gallerySwiper = new Swiper(gallery, {
            slidesPerView: 'auto',
            spaceBetween: 15,
            loop: true,
            loopedSlides: slideLength,
            speed: 10000,
            autoplay: {
                delay: 0,
                pauseOnMouseEnter: false,
                disableOnInteraction: false,
            },
            freeMode: {
                enabled: true,
                momentum: false,
            },
            on: {
                touchEnd: (swiper) => {
                    swiper.slideTo(swiper.activeIndex + 1);
                }
            },

        });
    }
}